<template>
  <van-popup
    v-model="show"
    round
    position="bottom"
    :style="{ height: '40%' }"
    @close="handleChange"
  >
    <div class="title">请输入服务卡密码</div>
    <div class="sub-title">实物卡请刮开图层查看密码</div>
    <label class="input-box-layout">
      <div
        class="input-box-item"
        v-for="index in 8"
        :key="'input-' + index"
        @click="inputFocus"
      >
        {{ input.substr(index - 1, 1) }}
      </div>
      <input
        ref="inputVal"
        type="text"
        maxlength="8"
        v-model="input"
        @blur="onblur"
        @input="onInputChange"
      />
    </label>
    <button @click="submit" type="password" :disabled="input.length !==8">激活</button>
  </van-popup>
</template>

<script>
export default {
  name: "ActivateCareDialog",
  data() {
    return {
      show: false,
      input: ""
    };
  },
  watch: {
    value(val) {
      this.show = val;
      this.input = ""
      if (val) {
        this.inputFocus();
      }
    }
  },
  props: {
    value: {
      default: false,
      type: Boolean
    }
  },
  mounted() {
  },
  methods: {
    onblur() {
      window.scrollTo(0, 0);
    },
    onInputChange(e) {
      this.input = e.target.value.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
    },
    inputFocus() {
      this.$nextTick(() => {
        this.$refs.inputVal.focus();
      });
    },
    submit() {
      if(!/^[a-zA-Z].*/.test(this.input)){
        this.$toast("输入错误，请重新输入")
        this.input = ""
        return
      }
    },
    handleChange(value) {
      this.$emit("callback", { success: false, dialog: value });
    }
  }
};
</script>

<style scoped>
.dialog {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
}

.van-popup {
  padding: 50px 30px 0;
  width: 100%;
  box-sizing: border-box;
  text-align: left;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.title {
  font-size: 14px;
  color: black;
  font-weight: 500;
}
.sub-title {
  font-size: 10px;
  color: #999999;
  font-weight: 400;
}
input {
  font-size: 20px;
  font-weight: 500;
  position: absolute;
  clip: rect(0px, 0px, 0px, 0px);
  caret-color: transparent;
}

.input-box-layout {
  font-size: 20px;
  font-weight: 500;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  width: 100%;
  margin-top: 20px;
}
.input-box-item {
  width: 20px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  border-bottom: #666666 2px solid;
}
button {
  font-size: 16px;
  height: 44px;
  line-height: 46px;
  background: linear-gradient(
    90deg,
    #333578,
    #323560
  );
  border-radius: 23px;
  border: none;
  width: 100%;
  color: white;
  margin-top: 40px;
}
button:disabled{
  background: linear-gradient(
    90deg,
    #999999,#666666
  );
}
::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  letter-spacing: 0;
}
</style>